module.exports = __webpack_public_path__ + "img/pic_yinhangka.3b5d2b64.png";